import React from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import TXT from "presentational/common/multinational/TXT";
import CommonTextField from "presentational/common/CommonTextField";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const MAX_LENGTH_OF_FOLDER = config.folderName.MAX_LENGTH;

FolderNameInputModalView.propTypes = {
  open: PropTypes.bool.isRequired,
  value: PropTypes.string,
  modalType: PropTypes.oneOf(["create", "edit"]).isRequired,
  folderName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

function FolderNameInputModalView(props) {
  const { value, modalType, folderName, open, onClose, onChange, onSubmit } =
    props;

  const isTextTooLong = text => {
    if (!text) return false;
    return text.length > MAX_LENGTH_OF_FOLDER;
  };

  const getTitle = () => {
    switch (modalType) {
      case "create":
        return <TXT name="titleModal_createFolder" />;
      case "edit":
        if (!folderName) console.error(`null input => "${folderName}"`);
        return <TXT name="titleModal_editFolderName" input={{ folderName }} />;

      default:
        console.log("error");
        console.error("error");
        break;
    }
  };

  const changeValue = value => {
    onChange(value);
  };

  const submitValue = () => {
    onSubmit({ type: modalType });
    onClose();
  };

  const handleKeyPress = e => {
    if (e.key === "Enter") {
      submitValue();
      e.preventDefault();
    }
  };

  const handleChange = e => {
    const { value } = e.target;
    if (!isTextTooLong(value)) changeValue(value);
  };

  const handleSubmit = () => {
    submitValue();
  };

  return (
    <CommonModalView
      open={open}
      onClose={onClose}
      paperStyle={{ width: "100%" }}
      titleText={getTitle()}
      contentComponent={
        <CommonTextField
          autoFocus
          value={value || ""}
          onKeyDown={handleKeyPress}
          onChange={handleChange}
          margin="normal"
        />
      }
      firstButtonText={<TXT name="btnModal_cancel" />}
      firstButtonFunc={onClose}
      secondButtonText={<TXT name="btnModal_submit" />}
      secondButtonFunc={handleSubmit}
      secondButtonDisabled={isTextTooLong(value)}
    />
  );
}

export default FolderNameInputModalView;
